import "core-js/modules/es.array.push.js";
/* eslint-disable no-undef */
// import { configurationsData } from "@/data/server";
export const useImagesStore = defineStore('images', () => {
  // STATE ------------------------------------------------------------------
  // Configuration data
  const MAX_FILES = 3;
  const MAX_FILE_SIZE_BASE = 20;
  const MAX_FILE_SIZE = MAX_FILE_SIZE_BASE * 1024 * 1024; // 20MB
  const ACCEPT_FORMATS = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];
  const ACCEPT_FORMATS_STRING = ACCEPT_FORMATS.join(',');
  const ACCEPT_FORMATS_DISPLAY = ACCEPT_FORMATS.map(format => format.toUpperCase()).join(' ');

  // Mutable state
  const images = ref([]);
  const TOTAL_COUNT = ref(0);

  // ACTIONS ----------------------------------------------------------------
  const addImages = newImages => {
    images.value.push(...newImages);
  };
  const addUploadedImages = newImages => {
    images.value.unshift(...newImages);
  };
  const removeImageById = id => {
    const index = images.value.findIndex(image => image._id === id);
    images.value.splice(index, 1);
  };
  return {
    MAX_FILES,
    MAX_FILE_SIZE_BASE,
    MAX_FILE_SIZE,
    ACCEPT_FORMATS,
    ACCEPT_FORMATS_STRING,
    ACCEPT_FORMATS_DISPLAY,
    TOTAL_COUNT,
    images,
    // ACTIONS
    addImages,
    addUploadedImages,
    removeImageById
  };
});